<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-04-16 10:23:16
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-14 14:41:09
-->
<template>
  <div>
    <el-form-item label="文本">
      <el-input v-model="option.content" placeholder="请输入" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'drag-text',
  props: ['option'],
  computed: {
    styleSize() {
      return {
        width: '50%',
        height: 'auto'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/dragComponents/styles/variables.scss";

.text {
  &-pannel {
    padding: calc($padding / 2);
    box-sizing: border-box;
    transition: all 0.5s;

    h3 {
      text-align: left;
      font-size: 15px;
      color: $color-666;
    }
  }
}
</style>
